import React, { useState } from "react";
import Button from "@/components/common/button/Button";
import Input from "@/components/common/input/Input";
import styles from "./DateRangeFilter.module.css";

interface DateRangeFilterProps {
    onFilter: (dates: { created_at__gte: string; created_at__lte: string }) => void;
}

const DateRangeFilter: React.FC<DateRangeFilterProps> = ({ onFilter }) => {
    const [startDate, setStartDate] = useState("");
    const [endDate, setEndDate] = useState("");

    const handleFilterClick = () => {
        onFilter({ created_at__gte: startDate, created_at__lte: endDate });
    };

    return (
        <div className={styles["filter-bar"]}>
            <div className={styles["filter-group"]}>
                <Input
                    id="startDate"
                    label="Desde"
                    type="date"
                    value={startDate}
                    onChange={(e) => setStartDate(e.target.value)}
                    placeholder="mm/dd/yyyy"
                />
            </div>
            <div className={styles["filter-group"]}>
                <Input
                    id="endDate"
                    label="Hasta"
                    type="date"
                    value={endDate}
                    onChange={(e) => setEndDate(e.target.value)}
                    placeholder="mm/dd/yyyy"
                />
            </div>
            <Button onClick={handleFilterClick} className={styles["filter-btn"]}>
                Filtrar por Fecha
            </Button>
        </div>
    );
};

export default DateRangeFilter;
